import PateintsChartsWrapper from '../patientcharts/patientchartwrap';
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import useStore from '../../store/zustandstore';
import Orders from '../../orders/orders';
import { eventBus } from '../../utils/eventBus';
import { se } from 'date-fns/locale';
import ToastMessage from '../../utils/mui/righttoptoast';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector } from 'react-redux';
import { clinicTodayKey, startDateKey } from '../cards/visitflow';
import { chartOrdersPanelShown } from '../../config/practice';
import { useCareiqN3Chart } from '../../utils/careiqN3Flag';
const ModalOverlay = ({ isOpen, onClose,isloaderactive,setFetchedData, fetchedData,modaldata,fetchpcarddata, dob, searchdate }) => {
  const setSidenav = useStore((state) => state.setSidenav);
  const [showOrders, setShowOrders] = useState(false);
const [ordersref, setOrdersref] = useState(false)
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const reduxDate = useSelector((state) => state.filter.currentDate);
const startDateObj = dayjs(modaldata.startdate, "YYYY-MM-DD HH:mm:ss");

// redux date (assume format YYYY-MM-DD)
console.log(modaldata,'modals')
const dtObj = dayjs(reduxDate, "YYYY-MM-DD");
// Orders open for the dashboard's day, and for today's visit: the chart
// resolver opens today's visit even from a card of another day.
const isSameDate = startDateObj.isSame(dtObj, "day") || startDateKey(modaldata?.startdate) === clinicTodayKey();
  const [toastSeverity, setToastSeverity] = useState("success");
  // The chart's Orders side tab + panel (9928: yes; 7825: no).
  const ordersPanel = chartOrdersPanelShown();
  // CareIQ N3 (per-login flag, read when the chart opens and kept until it
  // closes): the chart's CareIQ tab (patientchartwrap) and, below lg, the
  // Orders toggle as a bottom-right pill. From 768 px the redesigned shell
  // already fills the window (chartframe.css: 100vh - 64px). Below 768 px it
  // stacks the sidebar over the tab with no height of its own, so with the
  // flag the window is pinned to the bottom of the screen (bottom-0) and its
  // chart scrolls (n3-chartscroll, CareIQTabN3.css); otherwise the N3 tab sat
  // below the fold out of reach on a phone (10-06). Without the flag: as before.
  const careiqN3Flag = useCareiqN3Chart(Boolean(isOpen));
  const n3Frame = careiqN3Flag === "n3";
  const handleToastClose = () => {
    setOpenToast(false);
  };

  // The chart's top bar "Orders" button emits chartToggleOrders. The ref
  // keeps the listener on the latest handleToggle (it closes over state).
  const toggleRef = useRef(null);
  useEffect(() => {
    const onToggle = () => toggleRef.current && toggleRef.current();
    eventBus.on("chartToggleOrders", onToggle);
    return () => { eventBus.off("chartToggleOrders", onToggle); };
  }, []);

  if (!isOpen) return null;

  const handleToggle = () => {
    if(!showOrders&&!isSameDate){
      setToastMessage('Please schedule an appointment')
setToastSeverity('info')
setOpenToast(true)
return
    }
    if(showOrders){  
      eventBus.emit("fetchSummary")
    }
    setOrdersref(false)
    setShowOrders(!showOrders);
  };
  toggleRef.current = handleToggle;

// useEffect(()=>{
// console.log('s')
// },[showOrders])
  return (
    <div className={`fixed z-50 flex items-center justify-center w-full bg-black bg-opacity-50 top-16${n3Frame ? " bottom-0" : ""}`}>
      <div className="bg-white shadow-lg w-full h-full relative overflow-hidden">


        {/* Vertical Orders / Charts tab on the right edge opens and closes the
            panel. Not for a practice without orders in the chart (7825: OSA
            removed it; config/practice.js). */}
        {ordersPanel && <div
          className={n3Frame
            // N3 frame (flag): below lg the vertical side tab sat over the
            // stacked page (the critical Follow up row, the DOS row); it is a
            // bottom-right pill there instead, shown only while the Orders
            // panel is open ("Charts", back to the chart): closed, a pill
            // floating over the scrolling tab covered its rows' controls
            // (responsive audit 10-07), so the chart's top bar carries the
            // "Orders" button below lg (patientchartwrap -> NavFrame, the
            // chartToggleOrders event above). At lg: as before. (px-6, not
            // px-5: Bootstrap's .px-5 is 3rem !important.)
            ? `absolute bottom-4 right-4 lg:bottom-auto lg:top-[20%] lg:-right-6 transform lg:-translate-y-1/2 lg:rotate-90 origin-center px-6 py-2 rounded-full lg:rounded-md shadow-lg lg:shadow-none font-medium text-sm text-white cursor-pointer z-50${showOrders ? "" : " hidden lg:block"}`
            // Without the flag: the same classes as before.
            : "absolute top-[20%] -right-6 transform -translate-y-1/2 rotate-90 origin-center px-6 py-2 rounded-md font-medium text-sm text-white cursor-pointer z-50"}
          style={{ backgroundColor: "rgba(225, 121, 84, 1)" }}
          onClick={handleToggle}
        >
          {showOrders ?"Charts" : "Orders"}
        </div>}

        {/* Always render charts in background (the Orders tab lies over its edge). */}
        <div className={n3Frame ? "h-full w-full n3-chartscroll" : "h-full w-full"}>
          <PateintsChartsWrapper isloaderactive={isloaderactive}      setFetchedData={setFetchedData}
             fetchedData={fetchedData} onClose={onClose} fetchpcarddata={fetchpcarddata} data={modaldata} dob={dob} searchdate={searchdate}
             careiqN3Flag={careiqN3Flag} />
        </div>

        {/* Dim the chart behind the open Orders panel; a click there closes it
            the same way as the X (through the panel's unsaved-orders check). */}
        <div
          className={`absolute inset-0 z-30 bg-[rgba(15,23,42,0.45)] transition-opacity duration-500 ${showOrders ? "opacity-100" : "opacity-0 pointer-events-none"}`}
          onClick={() => { if (showOrders) setOrdersref(true); }}
          aria-hidden="true"
        />

        {/* Orders sliding panel. z-40: without a z-index this panel paints in
            the z-auto layer, so every positive-z element inside the chart
            (Labs/RPM/Payments sticky table headers z-10, CCM enroll button,
            CareIQ timeline dots) showed through it. Stays below the z-50
            close button and Orders/Charts toggle. Not mounted at all where
            the chart has no Orders tab (no order-catalogue requests). */}
        {ordersPanel && <div
          className={`absolute top-0 right-0 h-full z-40 bg-white shadow-2xl transition-transform duration-500 ease-in-out
          ${showOrders ? "translate-x-0" : "translate-x-full"} w-[95%]`}
        >
          <div className="max-h-[90vh] h-full overflow-auto">
            <Orders
              setShowOrders={setShowOrders}
              appointmentId={modaldata?.appointmentid}
              startDate={modaldata?.startdate}
              searchdate={searchdate}
ordersref={ordersref}
setOrdersref={setOrdersref}
               showOrders={showOrders}
            />
          </div>
        </div>}
    <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </div>
    </div>
  );
};

export default ModalOverlay;
